import getTimestamp from './get-timestamp';

export default function compare(a, b) {
  const aTime = getTimestamp(a.published_at);
  const bTime = getTimestamp(b.published_at);
  return aTime - bTime;
}
